import React from "react";
import ReactDOM from "react-dom";

export default class Modal extends React.Component {
  constructor(props) {
    super(props);
    this.el = document.createElement("div");
    this.el.className = "vp-modal-root";
  }

  componentDidMount() {
    document.body.appendChild(this.el);
    if (this.props.isOpen) document.body.style.overflow = "hidden";
  }

  componentDidUpdate(prevProps) {
    if (prevProps.isOpen !== this.props.isOpen) {
      document.body.style.overflow = this.props.isOpen ? "hidden" : "";
    }
  }

  componentWillUnmount() {
    document.body.style.overflow = "";
    if (this.el && this.el.parentNode) this.el.parentNode.removeChild(this.el);
  }

  renderContent() {
    const { isOpen, onClose, children, fullscreen } = this.props;
    if (!isOpen) return null;

    return (
      <div className="vp-modal-overlay" onClick={onClose}>
        <div
          className={`vp-modal${fullscreen ? ' vp-modal--fullscreen' : ''}`}
          onClick={(e) => e.stopPropagation()}
          role="dialog"
          aria-modal="true"
        >
          <button
            className={`vp-modal-close${fullscreen ? ' is-large' : ''}`}
            onClick={onClose}
            aria-label="Close"
          >
            ×
          </button>
          <div className="vp-modal-body">
            {children}
          </div>          
        </div>
      </div>
    );
  }

  render() {
    return ReactDOM.createPortal(this.renderContent(), this.el);
  }
}
